import moment from 'moment';
var BYPASS_AUTOUNBOOK = 'spaces:bypass_autounbook';
/**
 * CREATE only: when the event starts within the location confirmation window
 * from now, Robin auto-confirms — hide the manual pre-confirm control.
 * EDIT always returns false (legacy).
 */
export function canBeAutoConfirmed(_a) {
    var isEditing = _a.isEditing, confirmationWindow = _a.confirmationWindow, startedAt = _a.startedAt, _b = _a.now, now = _b === void 0 ? moment() : _b;
    if (isEditing)
        return false;
    if (!confirmationWindow || confirmationWindow.asMilliseconds() <= 0) {
        return false;
    }
    return startedAt.isBefore(now.clone().add(confirmationWindow));
}
/**
 * Allowed when the event is not already confirmed and every accepted space
 * has bypass_autounbook. Empty spaces ⇒ vacuous true (legacy `.every` on []).
 */
export function allowPreConfirm(_a) {
    var eventConfirmation = _a.eventConfirmation, spaces = _a.spaces;
    if (eventConfirmation)
        return false;
    return spaces.every(function (space) { var _a; return !!((_a = space === null || space === void 0 ? void 0 : space.permissions) === null || _a === void 0 ? void 0 : _a[BYPASS_AUTOUNBOOK]); });
}
export function shouldShowPreConfirmCheckbox(_a) {
    var isEditing = _a.isEditing, confirmationWindow = _a.confirmationWindow, startedAt = _a.startedAt, eventConfirmation = _a.eventConfirmation, spaces = _a.spaces, now = _a.now;
    return (!canBeAutoConfirmed({
        isEditing: isEditing,
        confirmationWindow: confirmationWindow,
        startedAt: startedAt,
        now: now,
    }) &&
        allowPreConfirm({
            eventConfirmation: eventConfirmation,
            spaces: spaces,
        }));
}
export function parseConfirmationWindow(value) {
    if (!value)
        return null;
    var duration = moment.duration(value);
    return Number.isFinite(duration.asMilliseconds()) &&
        duration.asMilliseconds() > 0
        ? duration
        : null;
}
